import { render, staticRenderFns } from "./ApprovalReminderDialog.vue?vue&type=template&id=fbca4d44&scoped=true&"
import script from "./ApprovalReminderDialog.vue?vue&type=script&lang=js&"
export * from "./ApprovalReminderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbca4d44",
  null
  
)

export default component.exports